import { render, staticRenderFns } from "./gs-dialog.vue?vue&type=template&id=728d7972&scoped=true&"
import script from "./gs-dialog.vue?vue&type=script&lang=ts&"
export * from "./gs-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./gs-dialog.vue?vue&type=style&index=0&id=728d7972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d7972",
  null
  
)

export default component.exports